var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPulso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 247,
    height: 137,
    viewBox: "0 0 247 137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Employee_Pulse_Survey"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 137
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Employee_Pulse_Survey",
    "data-name": "Employee Pulse Survey",
    clipPath: "url(#clip-Employee_Pulse_Survey)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6041",
    "data-name": "Group 6041",
    transform: "translate(-864.722 -2912.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7945",
    "data-name": "Path 7945",
    d: "M1040.343,184.577c-.186,15.57-18.332,43.164-26.389,66.187H848.345c-34.277-5.26-48.369-31.017-48.369-63.663,0-38.365,66.047-74.328,112-37.834a30.367,30.367,0,0,0,23.008,6.515c28.109-3.944,23.807-26.425,47.869-34.324a42.987,42.987,0,0,1,26.535.141C1040,131.417,1040.658,158.2,1040.343,184.577Z",
    transform: "translate(67.746 2796.316)",
    fill: "#e9f2fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5375",
    "data-name": "Group 5375",
    transform: "translate(914.164 2918.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7880",
    "data-name": "Path 7880",
    d: "M330.657,86.128c-1.532-.161-29.072-.441-30.734,0v4.684h30.734Z",
    transform: "translate(-236.855 -85.891)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7881",
    "data-name": "Path 7881",
    d: "M129.5,239.64c-.279-.226.116-.606-.589-.25a8.757,8.757,0,0,0-4.867,3.477,16.155,16.155,0,0,0-2.426,9.2c-.05,4.109-.149,7.413-.149,7.413l.295.261a12.262,12.262,0,0,0,2.428.263c.7-.08,5.481-.174,6.656-.231s5.951-.005,5.951-.005l.266-.37a36.981,36.981,0,0,0,1.159-7.824l-.014-2.246.2.009,2.98,2.16a3.488,3.488,0,0,1-.247-2.5,11.273,11.273,0,0,1,1.958-4.246l.195-.183s-3.571-3.577-6.745-4.394-4.564-.356-4.564-.356A2.312,2.312,0,0,1,129.5,239.64Z",
    transform: "translate(-113.18 -192.171)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7882",
    "data-name": "Path 7882",
    d: "M172.091,282.106a35.872,35.872,0,0,0,1.2-10.441",
    transform: "translate(-148.263 -214.64)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7883",
    "data-name": "Path 7883",
    d: "M145.246,288.276",
    transform: "translate(-129.658 -226.152)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7884",
    "data-name": "Path 7884",
    d: "M145.246,297.323",
    transform: "translate(-129.658 -232.422)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5373",
    "data-name": "Group 5373",
    transform: "translate(41.564 24.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7885",
    "data-name": "Path 7885",
    d: "M233.059,166.976H229.87V268.2h3.189V166.976",
    transform: "translate(-229.87 -166.976)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_440",
    "data-name": "Line 440",
    x1: 1.156,
    transform: "translate(2.033 16.196)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_441",
    "data-name": "Line 441",
    x1: 0.718,
    transform: "translate(2.471 20.245)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_442",
    "data-name": "Line 442",
    x1: 1.156,
    transform: "translate(2.033 24.294)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_443",
    "data-name": "Line 443",
    x1: 0.718,
    transform: "translate(2.471 4.049)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_444",
    "data-name": "Line 444",
    x1: 1.156,
    transform: "translate(2.033 8.098)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_445",
    "data-name": "Line 445",
    x1: 0.718,
    transform: "translate(2.471 12.147)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_446",
    "data-name": "Line 446",
    x1: 0.718,
    transform: "translate(2.471 28.343)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_447",
    "data-name": "Line 447",
    x1: 1.156,
    transform: "translate(2.033 32.392)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_448",
    "data-name": "Line 448",
    x1: 0.718,
    transform: "translate(2.471 36.441)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_449",
    "data-name": "Line 449",
    x1: 1.375,
    transform: "translate(1.813 40.49)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_450",
    "data-name": "Line 450",
    x1: 0.718,
    transform: "translate(2.471 44.539)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_451",
    "data-name": "Line 451",
    x1: 1.375,
    transform: "translate(1.813 48.588)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_452",
    "data-name": "Line 452",
    x1: 0.718,
    transform: "translate(2.471 52.637)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_453",
    "data-name": "Line 453",
    x1: 1.375,
    transform: "translate(1.813 56.686)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_454",
    "data-name": "Line 454",
    x1: 0.718,
    transform: "translate(2.471 60.735)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_455",
    "data-name": "Line 455",
    x1: 1.375,
    transform: "translate(1.813 64.784)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_456",
    "data-name": "Line 456",
    x1: 0.718,
    transform: "translate(2.471 68.833)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_457",
    "data-name": "Line 457",
    x1: 1.375,
    transform: "translate(1.813 72.882)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_458",
    "data-name": "Line 458",
    x1: 0.718,
    transform: "translate(2.471 76.931)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_459",
    "data-name": "Line 459",
    x1: 1.375,
    transform: "translate(1.813 80.98)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_460",
    "data-name": "Line 460",
    x1: 0.718,
    transform: "translate(2.471 85.029)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_461",
    "data-name": "Line 461",
    x1: 1.375,
    transform: "translate(1.813 89.078)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_462",
    "data-name": "Line 462",
    x1: 0.718,
    transform: "translate(2.471 93.127)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_463",
    "data-name": "Line 463",
    x1: 1.375,
    transform: "translate(1.813 97.176)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7886",
    "data-name": "Path 7886",
    d: "M146.7,231.9l.195-1.243a2.382,2.382,0,0,0-.06-1.361,3.948,3.948,0,0,0-.3-.724",
    transform: "translate(-130.551 -184.772)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7887",
    "data-name": "Path 7887",
    d: "M121.455,259.728c.042-1.314.192-5.526.146-8.06,0,0-.131-10.67,7.718-12.258",
    transform: "translate(-113.17 -192.286)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7888",
    "data-name": "Path 7888",
    d: "M157.253,219.848c.444,2.66.423,4.231-.881,4.93-.011.005-1.175.442-1.175,1.148l.167.447",
    transform: "translate(-136.554 -178.729)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7889",
    "data-name": "Path 7889",
    d: "M148.8,207.419c-1.118,2.079-4.659-.295-5.258,3.379-.064,1.365.212,3.711,1.5,3.921-.107-.994-.56-1.651-.421-2.105.333-1.091.994.215,1.771-.24s.222-1.922.864-2.293,1.726.042,1.757,1.476c0,0,3.141-1.979.382-4.266A.392.392,0,0,0,148.8,207.419Z",
    transform: "translate(-128.47 -169.965)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7890",
    "data-name": "Path 7890",
    d: "M177.264,237.633l-7.936,7.443s-5.125-5.3-9.231-6.239a10.621,10.621,0,0,0-3.555-.224",
    transform: "translate(-137.486 -191.054)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7891",
    "data-name": "Path 7891",
    d: "M224.943,235.044s1.8.025,2.021-.652.287-2.118-.3-2.343-.562.56-.852.141v-1.432c-.734-.193-1.764,2.1-1.764,2.1",
    transform: "translate(-184.272 -186.282)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7892",
    "data-name": "Path 7892",
    d: "M168.123,251.658c3.737,1.608,6.847,5.491,9.725,5.491,2.269,0,6.692-9.008,8.336-12.4",
    transform: "translate(-145.513 -195.983)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7893",
    "data-name": "Path 7893",
    d: "M188.186,256.822c.033-3.337-4.75,4.863-2.176,6.6",
    transform: "translate(-157.382 -203.805)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7894",
    "data-name": "Path 7894",
    d: "M147.075,239.41c0,.435.965,1.186,2.906.435",
    transform: "translate(-130.926 -192.286)",
    fill: "none",
    stroke: "#202033",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7895",
    "data-name": "Path 7895",
    d: "M127.767,305.76c-7.85-.3-13.517.779-15.644-.16-4.259,8.339-3.987,50.827-4.051,52.43a52.093,52.093,0,0,0,5.906,0l6.27-33.645h0l-.025-.241c.263,2.251,3.448,30.93,3.817,33.018,1.205.076,3.924-.274,5.887-.386.36-3.539,1.047-46.228-2.261-51.176Z",
    transform: "translate(-103.896 -238.158)",
    fill: "#436eb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7896",
    "data-name": "Path 7896",
    d: "M115.56,491.369h-7.142l.365-2.413,3.591.188S114.994,490.21,115.56,491.369Z",
    transform: "translate(-104.135 -365.231)",
    fill: "#333",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7897",
    "data-name": "Path 7897",
    d: "M123.142,490.5a2.631,2.631,0,0,0-.373.6",
    transform: "translate(-114.081 -366.3)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7898",
    "data-name": "Path 7898",
    d: "M126.7,491.891c-.188.226-.271.349-.271.349",
    transform: "translate(-116.616 -367.265)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7899",
    "data-name": "Path 7899",
    d: "M167.742,491.369H160.6l.363-2.413,3.591.188S167.176,490.21,167.742,491.369Z",
    transform: "translate(-140.299 -365.231)",
    fill: "#333",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7900",
    "data-name": "Path 7900",
    d: "M175.319,490.5a2.631,2.631,0,0,0-.373.6",
    transform: "translate(-150.241 -366.3)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7901",
    "data-name": "Path 7901",
    d: "M178.655,491.736c-.188.226-.271.349-.271.349",
    transform: "translate(-152.624 -367.158)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7902",
    "data-name": "Path 7902",
    d: "M155.33,306.12c3.308,4.948,2.578,47.477,2.218,51.016-1.964.112-4.682.462-5.887.386-.369-2.088-3.554-30.767-3.817-33.018",
    transform: "translate(-131.458 -238.519)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7903",
    "data-name": "Path 7903",
    d: "M127.953,305.76c-7.85-.3-13.518.779-15.644-.16-4.259,8.339-3.987,50.827-4.051,52.43a52.1,52.1,0,0,0,5.906,0l6.27-33.645.463-4.565",
    transform: "translate(-104.024 -238.158)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_464",
    "data-name": "Line 464",
    x1: 0.366,
    y1: 5.155,
    transform: "translate(23.92 118.763)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_465",
    "data-name": "Line 465",
    x2: 0.269,
    y2: 4.504,
    transform: "translate(20.396 119.221)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_466",
    "data-name": "Line 466",
    y1: 3.966,
    x2: 0.154,
    transform: "translate(8.238 119.947)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_467",
    "data-name": "Line 467",
    x1: 0.413,
    y2: 3.855,
    transform: "translate(4.649 119.871)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7904",
    "data-name": "Path 7904",
    d: "M177.161,496.818H147.649",
    transform: "translate(-131.323 -370.68)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7905",
    "data-name": "Path 7905",
    d: "M95.2,496.818h10.436",
    transform: "translate(-94.464 -370.68)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7906",
    "data-name": "Path 7906",
    d: "M454.56,158.195c2.281-1.074,3-.5,3-.5s1.28-1.935,2.987-1.849,3.129,1.083,2.548,2.79c0,0,3.893-1.074,3.5,1.292h-2.134a1.914,1.914,0,0,1-2.793,1.009,2.8,2.8,0,0,1-2.716,1.591,2.694,2.694,0,0,1-2.289-1.862,2.475,2.475,0,0,1-2.832.776c-1.463-.4-.614-1.864-.072-2.6A2.1,2.1,0,0,1,454.56,158.195Z",
    transform: "translate(-342.96 -134.373)",
    fill: "#f7f8f9",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7907",
    "data-name": "Path 7907",
    d: "M214.882,114.648c-2.281,1.074-3,.5-3,.5s-1.28,1.935-2.987,1.849-3.129-1.083-2.547-2.79c0,0-3.893,1.074-3.5-1.292h2.134a1.915,1.915,0,0,1,2.793-1.009,2.8,2.8,0,0,1,2.716-1.591,2.694,2.694,0,0,1,2.289,1.862,2.474,2.474,0,0,1,2.832-.776c1.463.4.614,1.864.072,2.6A2.1,2.1,0,0,1,214.882,114.648Z",
    transform: "translate(-169.555 -102.801)",
    fill: "#f7f8f9",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7908",
    "data-name": "Path 7908",
    d: "M486.552,497.35H455.719",
    transform: "translate(-344.828 -371.049)",
    fill: "none",
    stroke: "#202033",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7909",
    "data-name": "Path 7909",
    d: "M557.794,323.731",
    transform: "translate(-415.571 -250.724)",
    fill: "#202033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7910",
    "data-name": "Path 7910",
    d: "M522.427,449.559",
    transform: "translate(-391.06 -337.928)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7911",
    "data-name": "Path 7911",
    d: "M546.013,449.654",
    transform: "translate(-407.406 -337.993)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7912",
    "data-name": "Path 7912",
    d: "M552.311,333.988",
    transform: "translate(-411.771 -257.832)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7913",
    "data-name": "Path 7913",
    d: "M492.709,389.157c-2.063-.476-9.8.906-11.14.452a8.178,8.178,0,0,1-2.134-1.049s-5.619,2.069-6.756,2.7c0,0-4.822,2.47-5.537,6.095-.4,2.017.513,7.2,1.934,12.049,1.58,5.384,3.718,10.345,3.862,10.058l3.08-.035s1.155-3.7,0-10.258-1.528-8.234-1.528-8.234a11.258,11.258,0,0,0,6.527-.216s-3.942,11.029-.855,19.123c1.246,4.753,11.756.1,18.338-.721l4.173-.7-.083-3.7s-9.707-1.631-13.967-.825l-1.412.271c.4.218,3.57-6.171,4.463-11.709A75.068,75.068,0,0,0,492.709,389.157Z",
    transform: "translate(-352.68 -295.653)",
    fill: "#ee7142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7914",
    "data-name": "Path 7914",
    d: "M508.068,427.7c-2.112,3.085-4.2,21.61,1.934,21.335,8.585-.384,15.646-3.336,19.627-3.48l-.083-3.7c-2.578-.266-13.38-2.33-17.445.289",
    transform: "translate(-379.635 -322.778)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7915",
    "data-name": "Path 7915",
    d: "M481.491,490.884l-.235-1.892-3.047.078s-3.555,1.04-3.555,2.158h6.532A.307.307,0,0,0,481.491,490.884Z",
    transform: "translate(-357.952 -365.256)",
    fill: "#333",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7916",
    "data-name": "Path 7916",
    d: "M482.331,489.718a1.581,1.581,0,0,0,.409.471",
    transform: "translate(-363.272 -365.759)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7917",
    "data-name": "Path 7917",
    d: "M479.716,490.786a1.212,1.212,0,0,0,.33.406",
    transform: "translate(-361.459 -366.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7918",
    "data-name": "Path 7918",
    d: "M511.61,336.258c2.474,2.165,3.818,3.649,4.015,6.538a14.748,14.748,0,0,1-.253,4.544l-1.313,5.262-2.128-.066-4.221.477c-2.509.394-4.8.37-6.563-.684l-.716-.654-2.578-5.405c2.2-1.771,3.622-4.335,6.411-8.345l4.466-2.111s-2.274,1.684-.421,2.937C509.739,339.054,510.866,338.314,511.61,336.258Z",
    transform: "translate(-374.029 -259.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7919",
    "data-name": "Path 7919",
    d: "M477.1,492.11a2.513,2.513,0,0,0,.26.332",
    transform: "translate(-359.646 -367.417)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7920",
    "data-name": "Path 7920",
    d: "M585.173,473.068l-1.892.235L583.11,477s1.29,2.908,2.408,2.908v-6.532A.307.307,0,0,0,585.173,473.068Z",
    transform: "translate(-433.116 -354.219)",
    fill: "#333",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7921",
    "data-name": "Path 7921",
    d: "M584.4,486.746a1.582,1.582,0,0,0,.471-.409",
    transform: "translate(-434.006 -363.416)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7922",
    "data-name": "Path 7922",
    d: "M585.463,489.538a1.216,1.216,0,0,0,.406-.33",
    transform: "translate(-434.746 -365.406)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7923",
    "data-name": "Path 7923",
    d: "M586.787,492.311a2.508,2.508,0,0,0,.333-.26",
    transform: "translate(-435.664 -367.376)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7924",
    "data-name": "Path 7924",
    d: "M479.65,388.56c-2.747.877-12.378,3.832-12.292,9.509.122,8.595,4.648,18.634,5.647,21.363h3.228c1.316-1.535-.225-15.844-2.059-19.554",
    transform: "translate(-352.894 -295.653)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7925",
    "data-name": "Path 7925",
    d: "M518.23,337.262a8.627,8.627,0,0,1,3.344,3.838c1.742,4.087-.079,9.088-.9,12.506a9.265,9.265,0,0,0-2.284-.049h-.006c-3.661.262-8.82,1.59-10.922-.481-.018-.025-.042-.043-.061-.067",
    transform: "translate(-380.649 -260.101)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_468",
    "data-name": "Line 468",
    y1: 0.924,
    x2: 2.829,
    transform: "translate(131.748 76.972)",
    fill: "none",
    stroke: "#202033",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7926",
    "data-name": "Path 7926",
    d: "M471.492,305.468c4.39,2.873,9.554,10.993,16.016,10.5",
    transform: "translate(-355.76 -238.067)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7927",
    "data-name": "Path 7927",
    d: "M533.595,336.837c-2.067,5.168-5.833,1.491-3-.188",
    transform: "translate(-396.014 -259.676)",
    fill: "none",
    stroke: "#202033",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7928",
    "data-name": "Path 7928",
    d: "M532.741,415.881c4.062-4.918,6-18.565,5.412-24.854",
    transform: "translate(-398.208 -297.363)",
    fill: "none",
    stroke: "#292933",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7929",
    "data-name": "Path 7929",
    d: "M499.355,426.185c-1.961.092-5.179,2.176-8.571.679",
    transform: "translate(-369.13 -321.729)",
    fill: "none",
    stroke: "#292933",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7930",
    "data-name": "Path 7930",
    d: "M542.675,307.849a3.756,3.756,0,0,1,3.215,4.228c-.3,2.031-1.374,3.461-3.448,3.157",
    transform: "translate(-404.932 -239.717)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7931",
    "data-name": "Path 7931",
    d: "M542.191,328.876l.157-2.183a2.122,2.122,0,0,1,.358-1.183,3.575,3.575,0,0,1,.433-.57",
    transform: "translate(-404.757 -251.562)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7932",
    "data-name": "Path 7932",
    d: "M532.23,314.106a4.051,4.051,0,0,0-1.677,3.23c-.071,1.392.531,2.139,1.425,2.217l-.714,1.473",
    transform: "translate(-396.688 -244.053)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_856",
    "data-name": "Ellipse 856",
    cx: 2.515,
    cy: 3.431,
    rx: 2.515,
    ry: 3.431,
    transform: "translate(133.032 72.233) rotate(-81.663)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7933",
    "data-name": "Path 7933",
    d: "M469.816,365.618l-4.968-.381L461.14,364.2c-1.342-.448-.661-.03-1.276-.47l-.563.515a17.844,17.844,0,0,0-1.9,1.741,39.385,39.385,0,0,0,8.576,3.708l6.421,1.326Z",
    transform: "translate(-345.992 -278.447)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_857",
    "data-name": "Ellipse 857",
    cx: 1.12,
    cy: 0.855,
    rx: 1.12,
    ry: 0.855,
    transform: "translate(137.077 73.854) rotate(-81.663)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_858",
    "data-name": "Ellipse 858",
    cx: 2.625,
    cy: 2.679,
    rx: 2.625,
    ry: 2.679,
    transform: "translate(138.254 72.34) rotate(-81.663)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7934",
    "data-name": "Path 7934",
    d: "M507.405,387.91a.391.391,0,0,0,.024-.288",
    transform: "translate(-380.649 -295.003)",
    fill: "none",
    stroke: "#202033",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1791",
    "data-name": "Rectangle 1791",
    width: 17.487,
    height: 2.098,
    transform: "translate(110.772 71.903) rotate(90)",
    fill: "#8aceb6",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5374",
    "data-name": "Group 5374",
    transform: "translate(109.876 71.903)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_469",
    "data-name": "Line 469",
    x1: 0.525,
    transform: "translate(0.371 0)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_470",
    "data-name": "Line 470",
    x1: 0.896,
    transform: "translate(0 2.498)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_471",
    "data-name": "Line 471",
    x1: 0.525,
    transform: "translate(0.371 4.996)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_472",
    "data-name": "Line 472",
    x1: 0.896,
    transform: "translate(0 7.494)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_473",
    "data-name": "Line 473",
    x1: 0.525,
    transform: "translate(0.371 9.992)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_474",
    "data-name": "Line 474",
    x1: 0.896,
    transform: "translate(0 12.49)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_475",
    "data-name": "Line 475",
    x1: 0.525,
    transform: "translate(0.371 14.989)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_476",
    "data-name": "Line 476",
    x1: 0.525,
    transform: "translate(0.371 17.487)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7935",
    "data-name": "Path 7935",
    d: "M497.853,369.874",
    transform: "translate(-374.029 -282.703)",
    fill: "#fff",
    stroke: "#202033",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7936",
    "data-name": "Path 7936",
    d: "M459.864,356.5l-2.466,2.256c8.591,5.551,31.685,10.263,29.894-5.461",
    transform: "translate(-345.992 -271.21)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7937",
    "data-name": "Path 7937",
    d: "M483.749,358.332c-7.07,6.26-18.318,1.658-18.318,1.658",
    transform: "translate(-351.559 -274.704)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7938",
    "data-name": "Path 7938",
    d: "M448.5,305.412v-3.26a3.261,3.261,0,0,1,3.261-3.26h.538a3.261,3.261,0,0,1,3.261,3.26h0a3.26,3.26,0,0,1-3.261,3.26h-3.8",
    transform: "translate(-339.823 -233.509)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_859",
    "data-name": "Ellipse 859",
    cx: 1.242,
    cy: 1.242,
    r: 1.242,
    transform: "translate(110.961 67.401)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7939",
    "data-name": "Path 7939",
    d: "M469.326,304.017c-.077-1.036-.765-1.079-.909-1.574-.3-1.016,1.46-.05,1.568.086.981,1.236,1.935,2.654,2.463,3.125",
    transform: "translate(-353.605 -235.652)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7940",
    "data-name": "Path 7940",
    d: "M482.936,331.78c-2.665-.732-9.47-9.084-12.2-12.351-.487-.582-.87-1.238-1.617-1.374-.464-.085-.754-.281-1.394-.427",
    transform: "translate(-353.146 -246.493)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7941",
    "data-name": "Path 7941",
    d: "M453.145,366.6c-.364-.371-1.835.193-2.036-.52-.215-.766,1.2-.429,1.742-1.313",
    transform: "translate(-341.618 -279.162)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7942",
    "data-name": "Path 7942",
    d: "M459.247,359.1a4.371,4.371,0,0,0-3.3-2.263",
    transform: "translate(-344.988 -273.668)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_477",
    "data-name": "Line 477",
    x1: 1.39,
    y2: 2.333,
    transform: "translate(117.117 69.649)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7943",
    "data-name": "Path 7943",
    d: "M314.318,233.29H259.67c-.648-9.669-.828-104.664,0-115.186a1.535,1.535,0,0,1,1.535-1.535h51.578a1.535,1.535,0,0,1,1.535,1.535C315.433,142,314.617,226.373,314.318,233.29Z",
    transform: "translate(-208.573 -107.152)",
    fill: "#a1c4e7",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1792",
    "data-name": "Rectangle 1792",
    width: 44.778,
    height: 10.301,
    rx: 2,
    transform: "translate(56.032 14.971)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1793",
    "data-name": "Rectangle 1793",
    width: 44.778,
    height: 10.301,
    rx: 2,
    transform: "translate(56.032 33.425)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1794",
    "data-name": "Rectangle 1794",
    width: 44.778,
    height: 10.301,
    rx: 2,
    transform: "translate(56.032 51.88)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1795",
    "data-name": "Rectangle 1795",
    width: 44.778,
    height: 10.301,
    rx: 2,
    transform: "translate(56.032 70.334)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1796",
    "data-name": "Rectangle 1796",
    width: 44.778,
    height: 10.301,
    rx: 2,
    transform: "translate(56.032 88.788)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1797",
    "data-name": "Rectangle 1797",
    width: 39.022,
    height: 2.504,
    transform: "translate(58.909 102.742)",
    fill: "#f5ce72",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1798",
    "data-name": "Rectangle 1798",
    width: 36.864,
    height: 20.892,
    transform: "translate(60.032 105.246)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_478",
    "data-name": "Line 478",
    y2: 20.892,
    transform: "translate(70.008 105.246)",
    fill: "#e9f0f9",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_479",
    "data-name": "Line 479",
    y2: 20.892,
    transform: "translate(87.054 105.246)",
    fill: "#e9f0f9",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_480",
    "data-name": "Line 480",
    y2: 6.504,
    transform: "translate(80.205 113.217)",
    fill: "#e9f0f9",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_481",
    "data-name": "Line 481",
    y2: 6.504,
    transform: "translate(76.809 113.217)",
    fill: "#e9f0f9",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7944",
    "data-name": "Path 7944",
    d: "M320.161,96.941c-8.685.51-33.98-.55-41.688-.237A1.533,1.533,0,0,0,277,98.238v4.523h44.777V98.474A1.533,1.533,0,0,0,320.161,96.941Z",
    transform: "translate(-220.97 -93.344)",
    fill: "#e9f0f9",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_482",
    "data-name": "Line 482",
    x1: 59.091,
    transform: "translate(49.233 126.138)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulso);
export default __webpack_public_path__ + "static/media/pulso.9ebe81d9c9a4d922ee0e9f74be399669.svg";
export { ForwardRef as ReactComponent };